import { Typography } from "@mui/material";
import * as moment from "moment";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { DatePicker } from "source/components/framework/DateTime/DatePicker";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { FormFieldMargin } from "./TaskDynamicForm.styles";
import { DisabledInputClickEnabler } from "./DisabledInputClickEnabler";
import { getFormFieldTitle, getFormFieldTitleColor } from "./TaskDynamicFormFieldUtils";

export interface ITaskDynamicFormDateProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName: boolean;
    showFieldNameColor: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormDate extends React.Component<ITaskDynamicFormDateProp, {}> {
    handleChange = (value: moment.Moment | string) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (typeof value === "string") {
            if (Base.isNullOrEmpty(value)) {
                newValue.valueNbr = typeCol.required ? 0 : null;
            } else {
                newValue.valueNbr = value.toUtcDate().getTime();
            }
        } else {
            newValue.valueNbr = newValue.valueStr.toUtcDate().getTime();
        }
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <FormField title={getFormFieldTitle(typeCol, props.showFieldName)} titleColor={getFormFieldTitleColor(props.showFieldName, props.showFieldNameColor)} required={typeCol.required && !props.isReadOnly} margin={FormFieldMargin}>
                {props.isReadOnly &&
                    <Typography>{dataCol?.valueStr}</Typography>
                }
                {!props.isReadOnly &&
                    <DisabledInputClickEnabler
                        input={<DatePicker
                            value={dataCol?.valueStr || ""}
                            disabled={props.colIsReadOnly}
                            onChange={this.handleChange}
                        />}
                        disabled={props.colIsReadOnly}
                    />
                }
            </FormField>
        );
    }
}